import fetcher_v2 from "../fetcher_v2";
import { URLS } from "../urls";

interface ApiTokenResponse {
  token: string;
}

export const getApiToken = async () => {
  return fetcher_v2<ApiTokenResponse, void, { error: string }>(URLS.API_TOKEN);
};

export const createApiToken = async () => {
  return fetcher_v2<ApiTokenResponse, void, { error: string }>(URLS.API_TOKEN, {
    method: "POST",
  });
};

export const destroyApiToken = async () => {
  return fetcher_v2<void, void, { error: string }>(URLS.API_TOKEN, {
    method: "DELETE",
  });
};
